export default {
  // Usage based values:
  heading: 200,
  body: 400,
  lowContrast: 600,
  // Literal values (try to avoid as much as possible):
  light: 200,
  regular: 400,
  semibold: 600,
  bold: 700
};